import React from "react";
import { Row, Col, Card, CardBody, Button } from "reactstrap";
import CountUp from "react-countup";
import FeatherIcon from "feather-icons-react";
import Chart from "react-apexcharts";

const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};


const PlaybookTiles = () => {
  const donutOptions = {
    chart: { type: "donut" },
    labels: ["Threat Feeds (30%)", "EDR (25%)", "Pulse (45%)"],
    legend: { show: false },
    colors: ["#FF5B00", "#b63c17ff", "#FFFD98"],
    dataLabels: { enabled: false },
    stroke: { width: 0 },
  };

  const donutSeries = [30, 25, 45];

  const tiles = [
    {
      label: "Total Playbooks Triggered Today",
      counter: 1245,
      subText: "+12% from yesterday",
      icon: "play-circle",
      iconColor: "primary"
    },
    {
      label: "Automated Incidents Closed",
      counter: 897,
      subText: "98% success rate",
      icon: "check-circle",
      iconColor: "warning",
    },
    {
      label: "Failed Playbook Executions",
      counter: 38,
      subText: "2.8% failure rate",
      icon: "x-circle",
      iconColor: "danger",
    },
  ];

  const [hoveredCard, setHoveredCard] = React.useState(null);

  return (
    <>
      {/* Top Buttons */}
      <Row className="align-items-center mb-4">
        <Col className="text-end">
          <Button color="primary" className="me-2 shadow-sm fw-medium border">
            <FeatherIcon icon="plus-circle" size="16" className="me-1" />
            Create Playbook
          </Button>
          <Button color="primary" className="me-2 shadow-sm fw-medium border">
            <FeatherIcon icon="folder" size="16" className="me-1" />
            Open Incidents
          </Button>
          <Button color="primary" className="shadow-sm fw-medium border">
            <FeatherIcon icon="eye" size="16" className="me-1" />
            View Logs
          </Button>
        </Col>
      </Row>

      {/* Metric Cards */}
      <Row className="mb-4 gx-3">
        {tiles.map((item, key) => (
          <Col xl={3} md={6} key={key}>
            <Card className="shadow-sm border h-100 d-flex flex-column"
              style={{
                ...cardShell,
                transition: "all 0.3s ease",
                transform:
                  hoveredCard === key ? "translateY(-4px)" : "translateY(0)",

              }}
              onMouseEnter={() => setHoveredCard(key)}
              onMouseLeave={() => setHoveredCard(null)} >

              <CardBody className="d-flex flex-column justify-content-between h-100">

                <div className="d-flex justify-content-between align-items-start">
                  <p className="fw-medium text-muted mb-0">{item.label}</p>
                  <FeatherIcon
                    icon={item.icon}
                    size="18"
                    className={`text-${item.iconColor}`}
                  />
                </div>


                <div className="d-flex justify-content-center align-items-center flex-grow-1">
                  <h2 className="fw-bold mb-0" style={{ color: "#494545" }}>
                    <CountUp
                      start={0}
                      end={item.counter}
                      separator=","
                      duration={2}
                    />
                  </h2>
                </div>


                <p className="text-muted small mb-0">{item.subText}</p>
              </CardBody>
            </Card>
          </Col>
        ))}


        <Col xl={3} md={6}>
          <Card className="h-100 d-flex flex-column"
            style={{
              ...cardShell,
              
            }}>
            <CardBody className="d-flex flex-column justify-content-between h-100">
              <div className="d-flex justify-content-between align-items-start">
                <p className="fw-medium text-muted mb-0">Top 3 Alert Sources</p>
                <FeatherIcon icon="pie-chart" size="18" className="text-warning" />
              </div>
              <div className="d-flex justify-content-center align-items-center flex-grow-1 flex-column">
                <h5 className="fw-bold mb-3" style={{ color: "#494848ff" }}>Pulse (45%)</h5>
                <Chart
                  options={donutOptions}
                  series={donutSeries}
                  type="donut"
                  height="120"
                />
              </div>
              <p className="text-muted small mb-0">
                Threat feeds (30%), EDR (25%)
              </p>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default PlaybookTiles;
